// Google Cloud Storage avatars bucket name
export const avatarsBucketName = 'banani-avatars';
export const avatarsBucketUri = `https://storage.googleapis.com/${avatarsBucketName}`;

export const generatedImagesBucket = 'banani-generated-images';
export const generatedImagesBucketUri = `https://storage.googleapis.com/${generatedImagesBucket}`;

export const userAvatarsBucketName = 'banani-user-avatars';

export const screenshotsBucket = 'banani-screenshots';
export const screenshotsBucketUri = `https://storage.googleapis.com/${screenshotsBucket}`;
